// @flow

import React, { useState, useEffect } from 'react';
import { log } from '../../utils/jsUtils';
import { useSelector } from 'react-redux';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';

import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';

import CreditCardForm from '../SharedComponents/CreditCardForm';
import SPBackend from '../../services/SPBackend';
import StripeElementWrapper from './StripeElementWrapper';
import { useTheme } from '@mui/material/styles';
import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/ConfirmTopupPurchaseDialog.Style';
import sharedDialogStyles from '../Styles/SharedDialogStyles';
import Typography from '@mui/material/Typography';
import { selectUser } from '../../reduxStore/modules/user/selectors';

import type { Plan } from '../../services/SPBackend';

type Props = {
  setOpen: Function,
  isActionLoading: Boolean,
  open: boolean,
  triggerAction: Function,
  onPaymentMethodSelected: Function,
  defaultPaymentMethod: Object
};

// eslint-disable-next-line react/no-multi-comp
const UpdatePaymentMethodDialog = (props: Props) => {
  const theme = useTheme();
  const classes = createClasses({
    ...styles,
    ...sharedDialogStyles
  }, theme);
  
  const {
    setOpen,
    open,
    triggerAction, // onPaymentMethodSelected
    isActionLoading,
    defaultPaymentMethod
  } = props;
  
  const user = useSelector(selectUser);
  

  log('[UpdatePaymentMethodDialog render] defaultPaymentMethod: ', defaultPaymentMethod);
  const [newDefaultPM, setNewDefaultPM] = useState(null);

  const onPaymentMethodSelected = (pm) => {
    log('[UpdatePaymentMethodDialog.onPaymentMethodSelected] pm: ', pm);
    setNewDefaultPM(pm);
    triggerAction(pm);
    setOpen(false);
  };

  const onCancelClicked = () => {
    setOpen(false);
  };

  return (
    <Dialog aria-labelledby='form-confirm-topup'
      onClose={() => setOpen(false)}
      open={open}
    >
      <DialogTitle sx={classes.dialogHeader}>{'New payment method'}</DialogTitle>
      <DialogContent sx={{ ...classes.grow, ...classes.flexContainer }}>
        {
          !newDefaultPM
          ? <CreditCardForm 
              onCancelClicked={onCancelClicked}
              onPaymentMethodSelected={onPaymentMethodSelected}
            />
          : <Typography
                sx={classes.captionText}
                variant='body1'
            >Your credit card ending in {newDefaultPM.card.last4} will be used.</Typography>
        }
        
        <br />
      </DialogContent>
    </Dialog>
  );
};

export default UpdatePaymentMethodDialog;
